'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/app/lib/analytics';

const GlobalErrorListener = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    const handleError = (event: ErrorEvent) => {
      reportClientError(event.error instanceof Error ? event.error : new Error(event.message));
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      reportClientError(event.reason instanceof Error ? event.reason : new Error(String(event.reason)));
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, []);

  return null;
};

export default GlobalErrorListener;
